/**
 * CLEARO inline video — <clearo-video>
 * Muted autoplay loop while on screen (pauses when scrolled away or tab hidden),
 * play/pause and sound buttons, thin progress bar. Reduced motion: starts paused.
 * Markup & styles: sections/clearo-how-it-works.liquid
 */
(() => {
  if (customElements.get('clearo-video')) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class ClearoVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.playBtn = this.querySelector('[data-play]');
      this.soundBtn = this.querySelector('[data-sound]');
      this.bar = this.querySelector('[data-progress]');
      this.userPaused = reducedMotion.matches;
      this.inView = false;

      this.video.muted = true;
      this.video.removeAttribute('controls');
      this.setPaused(true);

      this.playBtn.addEventListener('click', () => {
        this.userPaused = !this.video.paused;
        this.userPaused ? this.video.pause() : this.play();
      });
      this.soundBtn.addEventListener('click', () => {
        this.video.muted = !this.video.muted;
        this.classList.toggle('has-sound', !this.video.muted);
        this.soundBtn.setAttribute('aria-pressed', String(!this.video.muted));
        this.soundBtn.setAttribute('aria-label', this.video.muted ? this.dataset.labelSoundOn || 'Turn sound on' : this.dataset.labelSoundOff || 'Turn sound off');
        if (!this.video.muted && this.video.paused) {
          this.userPaused = false;
          this.play();
        }
      });
      this.video.addEventListener('play', () => this.setPaused(false));
      this.video.addEventListener('pause', () => this.setPaused(true));
      this.video.addEventListener('timeupdate', () => {
        const d = this.video.duration || 1;
        this.bar.style.setProperty('--p', (this.video.currentTime / d).toFixed(3));
      });

      this.io = new IntersectionObserver(
        ([entry]) => {
          this.inView = entry.isIntersecting;
          this.auto();
        },
        { threshold: 0.35 }
      );
      this.io.observe(this);
      document.addEventListener('visibilitychange', () => this.auto());
    }

    disconnectedCallback() {
      this.io && this.io.disconnect();
    }

    auto() {
      if (this.inView && !document.hidden && !this.userPaused) this.play();
      else if (!this.video.paused) this.video.pause();
    }

    play() {
      const p = this.video.play();
      if (p && p.catch) p.catch(() => this.setPaused(true));
    }

    setPaused(paused) {
      this.classList.toggle('is-paused', paused);
      this.playBtn.setAttribute('aria-label', paused ? this.dataset.labelPlay || 'Play video' : this.dataset.labelPause || 'Pause video');
    }
  }

  customElements.define('clearo-video', ClearoVideo);
})();
